<div class="flex flex-col !gap-5">
  <div class="header flex flex-row items-center justify-between">
    <div class="flex flex-row items-center">
      <ion-icon src="../../../assets/icon/attention-icon.svg"></ion-icon>
      <h1>¡ATENCIÓN!</h1>
    </div>

    <ion-button fill="clear" class="close" (click)="close()">
      <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
    </ion-button>
  </div>

  <hr />

  <h2>
    Vas a establecer estos datos de {{ type === 'shipping' ? 'envío' : 'facturación' }} como POR DEFECTO para tus
    próximos pedidos.
  </h2>

  <div class="address-info flex flex-col gap-2.5">
    <span>
      {{ address.organization || address.recipient }}
    </span>

    <span *ngIf="type === 'billing'">
      {{ address.taxId }}
    </span>

    <span *ngIf="type === 'shipping'">
      {{ address.phone }}
    </span>
    <span *ngIf="type === 'shipping' && address.email">
      {{ address.email }}
    </span>

    <span>
      {{ address.addressLine1 }}
    </span>
    <span>
      {{ address.postalCode }}
    </span>
    <span> {{ address.city }}, {{ address.province }} </span>
  </div>

  <span class="message"> Podrás volver a cambiarlo luego desde “Mi cuenta > Mi perfil” o al hacer un pedido. </span>

  <hr />

  <div class="buttons flex flex-row items-center justify-end gap-2.5">
    <button class="gray" (click)="close()">Cancelar</button>
    <button class="blue" (click)="accept()">Aceptar y continuar</button>
  </div>
</div>
